import { memo } from 'react'

import { FiberManualRecord } from '@mui/icons-material'
import { Box, CircularProgress } from '@mui/material'
import { AvcInstanceTask } from '@nativewaves/nw-cloud-sdk/content'

import { getAvcInstanceStateColor } from 'utils'

type DynamicBadeProps = {
  state: AvcInstanceTask['state']
  health?: AvcInstanceTask['health']
}

const DynamicBadgeRaw = ({ state, health }: DynamicBadeProps) => {
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', ml: 2 }}>
      {state === 'STARTING' || state === 'PENDING' || state === 'STOPPING' ? (
        <CircularProgress
          size="1.2rem"
          style={{
            color: `${getAvcInstanceStateColor(state, health)[500]}`,
          }}
        />
      ) : (
        <FiberManualRecord
          fontSize="small"
          style={{
            color: `${getAvcInstanceStateColor(state, health)[500]}`,
          }}
        />
      )}
    </Box>
  )
}

export const DynamicBadge = memo(DynamicBadgeRaw)
